import * as React from 'react'

const LINAUSD = (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} width='48' height='48' viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <rect x='0.5' y='0.5' width='47' height='47' rx='23.5' fill='white' />
    <path
      d='M22.3372 39.6958C21.0258 38.6656 20.375 37.5962 20.3782 36.4875C20.3487 35.4708 20.7239 34.484 21.4215 33.7437L36.2886 18.8766C37.3122 19.7498 37.9172 20.7407 38.1134 21.8592C38.2143 22.4 38.1806 22.9573 38.0152 23.482C37.8498 24.0067 37.5578 24.4827 37.165 24.8679L22.3372 39.6958ZM17.0392 34.3978C15.7245 33.3643 15.0737 32.2949 15.0802 31.1895C15.0507 30.1728 15.4259 29.186 16.1235 28.4457L30.9906 13.5786C32.0109 14.4485 32.6192 15.4427 32.8154 16.5612C32.9153 17.1018 32.8808 17.6586 32.7148 18.1827C32.5489 18.7068 32.2566 19.1821 31.8638 19.5666L17.0392 34.3978ZM11.7379 29.0965C10.4232 28.0631 9.77242 26.9936 9.77896 25.8883C9.74947 24.8716 10.1247 23.8847 10.8222 23.1444L25.6893 8.27732C26.7129 9.15051 27.3179 10.1414 27.5142 11.2599C27.615 11.8007 27.5813 12.3581 27.4159 12.8828C27.2505 13.4075 26.9585 13.8834 26.5658 14.2686L11.7379 29.0965Z'
      fill='url(#paint0_linear_826_6756)'
    />
    <rect x='0.5' y='0.5' width='47' height='47' rx='23.5' stroke='#CAD0E1' />
    <defs>
      <linearGradient
        id='paint0_linear_826_6756'
        x1='-334.984'
        y1='-2061.89'
        x2='894.471'
        y2='-832.438'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#7EB5FF' />
        <stop offset='0.9997' stopColor='#1A38F8' />
      </linearGradient>
    </defs>
  </svg>
)

export default LINAUSD
